import CheckTree from './CheckTree';

export type { CheckTreeProps, ValueType } from './CheckTree';
export default CheckTree;
